import React from "react";

const Media = ({ media }) => {
	return (
		<div className="media">
			<img src={media} alt="" />
		</div>
	);
};

export default Media;
